import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { formatDate } from "../../utils/formatDate";

export const FilterAllActionsModal = ({
  show,
  handleClose,
  refetch,
  form,
  setForm,
}) => {
  return (
    <BootstrapModal
      modaltitle="فیتر فعالیت ها"
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <DataPicker
        onChange={(e) => setForm({ ...form, Start: formatDate(e) })}
        label="از تاریخ"
      />
      <DataPicker
        onChange={(e) => setForm({ ...form, End: formatDate(e) })}
        label="تا تاریخ"
      />
      <div className="row">
        <div className="col-6 mt-2">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              refetch();
              handleClose();
            }}
          >
            اعمال
          </Button>
        </div>
        <div className="col-6 mt-2">
          <Button bgColor="#f1416c" color="#fff" onclick={handleClose}>
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
